import { render } from "./profileScreen.vue?vue&type=template&id=f2341c5a&scoped=true"
import script from "./profileScreen.vue?vue&type=script&lang=js"
export * from "./profileScreen.vue?vue&type=script&lang=js"

import "./profileScreen.vue?vue&type=style&index=0&id=f2341c5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2341c5a"]])

export default __exports__